import dayjs from "dayjs";
import { gettext } from "@/services/translation";

const MonthsCase1 = ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"];
const MonthsCase2 = ["ledna", "února", "března", "dubna", "května", "června", "července", "srpna", "září", "října", "listopadu", "prosince"];

/**
 * @returns {string} Eg. "12. 11. 2023"
 **/
export function formateDate(dateStringOrDateObject: string | Date): string {
  const date = dayjs(dateStringOrDateObject);
  return date.format("D. M. YYYY");
}

/**
 * @returns {string} Eg. "2023"
 **/
export function getFullYear(dateString: string): string {
  const date = dayjs(dateString);
  return date.format("YYYY");
}

/**
 * @returns {string} Eg. "12. listopad"
 **/
export function formatDateDayAndMonth(dateString: string, grammaticalCase = 1): string {
  const date = dayjs(dateString);

  const day = date.date();
  const month = date.month();

  if (grammaticalCase === 2) {
    return day + ". " + MonthsCase2[month];
  } else {
    return day + ". " + MonthsCase1[month];
  }
}

/**
 * @param monthNumber Month number starting with January = 0.
 */
export function getMonthName(monthNumber: number, grammaticalCase = 1): string {
  if (grammaticalCase === 2) {
    return MonthsCase2[monthNumber];
  } else {
    return MonthsCase1[monthNumber];
  }
}

/**
 * Return string of type "before 7 days". More specifically:
 *   - if given date is of same day as today, returns "today"
 *   - if given date is one day before today, returns "yesterday"
 *   - if given date is max 30 days before today, returns "before X days"
 *   - otherwise returns date in D.M.YYYY. format
 **/
export function getDateBeforeString(dateStringOrDateObject: string | Date): string {
  const date = new Date(dateStringOrDateObject);
  const today = new Date();
  date.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  const diffTime = Math.abs(today.getTime() - date.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return gettext.$gettext("Dnes");
  } else if (diffDays === 1) {
    return gettext.$gettext("Včera");
  } else if (diffDays >= 2 && diffDays <= 30) {
    return gettext.$gettext("Před %{days} dny", { days: diffDays });
  } else {
    return formateDate(dateStringOrDateObject);
  }
}

/**
 * Formats a date string from "YYYY-MM" format to "Month Year" format.
 * @param release Date string in "YYYY-MM" format
 * @returns {string} Eg. "leden 2023"
 **/
export function formatYearAndMonth(str: string): string {
  const date = dayjs(str, "YYYY-MM");
  const year = date.year();
  const month = date.month();
  return `${getMonthName(month)} ${year}`;
}
